import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import React from 'react';
function InfoIcon(props) {
    return /*#__PURE__*/ _jsxs(Icon, {
        className: "ibaicon",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 1.75C5.44321 1.75 1.75 5.44321 1.75 10C1.75 14.5568 5.44321 18.25 10 18.25C14.5568 18.25 18.25 14.5568 18.25 10C18.25 5.44321 14.5568 1.75 10 1.75ZM0.25 10C0.25 4.61479 4.61479 0.25 10 0.25C15.3852 0.25 19.75 4.61479 19.75 10C19.75 15.3852 15.3852 19.75 10 19.75C4.61479 19.75 0.25 15.3852 0.25 10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 4.75C10.4142 4.75 10.75 5.08579 10.75 5.5V10.5C10.75 10.9142 10.4142 11.25 10 11.25C9.58579 11.25 9.25 10.9142 9.25 10.5V5.5C9.25 5.08579 9.58579 4.75 10 4.75Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.99603 13C9.44403 13 8.99603 13.448 9.00003 14C9.00003 14.552 9.44803 15 10 15C10.552 15 11 14.552 11 14C11 13.448 10.552 13 9.99603 13Z",
                fill: "currentColor"
            })
        ]
    });
}
export default InfoIcon;
